import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 24,
		height: 24,
		// backgroundColor: '#BCBBD0',

		'& > svg': {
			// margin: theme.spacing(2),
			// width: 24,
			// height: 24,
		},
	},
}));

function ArchiveIcon(props) {
	return (
		<svg width="24" height="24" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path opacity="0.5" fill-rule="evenodd" clip-rule="evenodd" d="M5.01379 3.56409C5.60797 2.01932 7.0921 1 8.74719 1H23.2528C24.9079 1 26.392 2.01932 26.9862 3.56409L30.7334 13.3068C30.82 13.5319 30.8858 13.764 30.9304 14H24.1569C22.8307 14 21.559 14.5268 20.6213 15.4645L19.9645 16.1213C19.4019 16.6839 18.6388 17 17.8431 17H14.1569C13.3612 17 12.5981 16.6839 12.0355 16.1213L11.3787 15.4645C10.441 14.5268 9.16925 14 7.84314 14H1.06958C1.1142 13.764 1.17999 13.5319 1.2666 13.3068L5.01379 3.56409ZM12 10C12 9.44772 12.4477 9 13 9H19C19.5523 9 20 9.44772 20 10C20 10.5523 19.5523 11 19 11H13C12.4477 11 12 10.5523 12 10ZM14 5C13.4477 5 13 5.44772 13 6C13 6.55228 13.4477 7 14 7H18C18.5523 7 19 6.55228 19 6C19 5.44772 18.5523 5 18 5H14Z" fill={props.fill} />
			<path fill-rule="evenodd" clip-rule="evenodd" d="M1 14V27C1 29.2091 2.79083 31 5 31H27C29.2092 31 31 29.2091 31 27V14H24.1569C22.8308 14 21.559 14.5268 20.6213 15.4645L19.9645 16.1213C19.4019 16.6839 18.6388 17 17.8431 17H14.1569C13.3612 17 12.5981 16.6839 12.0355 16.1213L11.3787 15.4645C10.441 14.5268 9.16923 14 7.84315 14H1ZM12 22C12.5523 22 13 22.4477 13 23C13 23.5523 13.4477 24 14 24H18C18.5523 24 19 23.5523 19 23C19 22.4477 19.4477 22 20 22C20.5523 22 21 22.4477 21 23C21 24.6569 19.6569 26 18 26H14C12.3431 26 11 24.6569 11 23C11 22.4477 11.4477 22 12 22Z" fill={props.fill} />
		</svg>
	);
}

export default function SvgIconsColor(props) {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<ArchiveIcon fill={props.fill} />
		</div>
	);
}